import React from "react";
import { Navbar } from "@/components/storefront/Navbar";
import { Footer } from "@/components/storefront/Footer";
import { Chatbot } from "@/components/storefront/Chatbot";
import { HelpButton } from "@/components/storefront/HelpButton";

export const StoreLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-cream">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <Chatbot />
    <HelpButton />
  </div>
);
